// @flow
import { createSelector } from 'reselect';

export const userSelector = createSelector(
  state => state.user,
  (user: $ElementType<ReduxState, 'user'>): $ElementType<ReduxState, 'user'> => user
);

export const payerSelector = createSelector(
  state => state.payer,
  (payer: $ElementType<ReduxState, 'payer'>): $ElementType<ReduxState, 'payer'> => payer
);

export const usersSelector = createSelector(
  state => state.users,
  (users: $ElementType<ReduxState, 'users'>): $ElementType<ReduxState, 'users'> => users
);
